<div class="agent-chat-chart">
  <div class="agent-chat-chart-head" *ngIf="block?.chart?.title || block?.chart?.note">
    <div class="agent-chat-chart-title" *ngIf="block?.chart?.title">
      {{ block?.chart?.title }}
    </div>
    <div class="agent-chat-chart-note" *ngIf="block?.chart?.note">
      {{ block?.chart?.note }}
    </div>
  </div>

  <div class="agent-chat-chart-empty" *ngIf="!hasSeries">
    {{ 'BALANCE.CHATBOT_CHART_EMPTY' | translate }}
  </div>

  <div class="agent-chat-chart-host" #chartHost [class.hidden]="!hasSeries"></div>
</div>
